(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-product]')];
    // Shopify can sort by base prices rather than the active Market's fixed prices.
    const sort = root.querySelector('select[name="sort_by"]').value;
    if (sort === 'price-ascending' || sort === 'price-descending') {
      const direction = sort === 'price-ascending' ? 1 : -1;
      cards.sort((a,b) => direction * (Number(a.dataset.price) - Number(b.dataset.price)));
      const grid = root.querySelector('.idv-wc__grid');
      cards.forEach(card => grid.append(card));
    }
    const filters = [...root.querySelectorAll('[data-women-filters] [data-category]')];
    const count = root.querySelector('[data-women-count]');
    const categories = new Set(cards.flatMap(card => card.dataset.categories.split(/\s+/)));
    filters.forEach(button => { button.hidden = button.dataset.category !== 'all' && !categories.has(button.dataset.category); });
    root.querySelector('[data-women-filters]').hidden = false;
    const valid = new Set(filters.filter(button => !button.hidden).map(button => button.dataset.category));
    function apply(value, updateURL) {
      const category = valid.has(value) ? value : 'all';
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && !card.dataset.categories.split(/\s+/).includes(category);
        if (!card.hidden) visible++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      count.textContent = `${visible} ${visible === 1 ? 'style' : 'styles'}`;
      root.querySelector('[data-women-empty]').hidden = visible !== 0;
      if (updateURL) {
        const url = new URL(location.href);
        if (category === 'all') url.searchParams.delete('style'); else url.searchParams.set('style', category);
        history.pushState(null, '', url);
      }
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button[data-category]');
      if (button) apply(button.dataset.category, true);
    });
    const restore = () => apply(new URL(location.href).searchParams.get('style'), false);
    window.addEventListener('popstate', restore);
    restore();
    const form = root.querySelector('form');
    // Keep the unpublished alternate template and selected category when sorting.
    form.addEventListener('submit', () => {
      for (const name of ['view','preview_theme_id','style']) {
        form.querySelector(`input[name="${name}"]`)?.remove();
        const value = new URL(location.href).searchParams.get(name);
        if (value) { const input = document.createElement('input'); input.type='hidden'; input.name=name; input.value=value; form.append(input); }
      }
    });
    form.querySelector('select').addEventListener('change', () => form.requestSubmit());
    form.querySelector('button').hidden = true;
    const params = new URL(location.href).searchParams;
    if (params.get('view')?.startsWith('idv-women-')) {
      root.querySelectorAll('[data-women-view]').forEach(link => {
        const url = new URL(link.href); url.searchParams.set('view', link.dataset.womenView); if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id')); link.href=url;
      });
    }
  }
  document.querySelectorAll('[data-women-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-women-collection]').forEach(init));
})();
